import { Controller } from "@hotwired/stimulus"

// Turbo never scrolls for a frame navigation — the page itself doesn't
// re-render, so it leaves the scroll position alone. Paging would otherwise
// leave the reader partway down, at whatever offset the loading state's
// collapsed height clamped them to. Put them back at the head of the results.
export default class extends Controller {
  scrollToResultsOnRender() {
    // The nav is inside the frame, so this controller is torn down by the very
    // render it's waiting for. The listener goes on the frame, which survives.
    const frame = this.element.closest("turbo-frame")
    const results = document.querySelector("[data-results-top]")
    if (!frame || !results) return

    frame.addEventListener(
      "turbo:frame-render",
      // A frame behind on layout measures its old height, so wait for the
      // paint. scroll-mt on the target clears the sticky navbar.
      () => requestAnimationFrame(
        () => results.scrollIntoView({ block: "start", behavior: "instant" })
      ),
      { once: true }
    )
  }
}
